import { buildColStyleString, getResponsiveWidthsByColumn } from './responsiveColWidth';
export function createColGroup(node, cellMinWidth, arg3, arg4, arg5) {
    var _a;
    const overrideCol = typeof arg3 === 'number' ? arg3 : undefined;
    const overrideValue = typeof arg3 === 'number' ? arg4 : undefined;
    const opts = (typeof arg3 === 'number' ? arg5 : arg3) || {};
    const currentBreakpoint = opts.breakpoint || 'lg';
    let totalWidth = 0;
    let fixedWidth = true;
    const cols = [];
    const row = node.firstChild;
    const responsiveWidthsByColumn = getResponsiveWidthsByColumn(((_a = node.attrs) === null || _a === void 0 ? void 0 : _a.style) || '');
    if (!row) {
        return {};
    }
    for (let i = 0, col = 0; i < row.childCount; i += 1) {
        const { colspan, colwidth } = row.child(i).attrs;
        for (let j = 0; j < colspan; j += 1, col += 1) {
            const hasWidth = overrideCol === col ? overrideValue : colwidth && colwidth[j];
            const responsiveWidths = responsiveWidthsByColumn.get(col);
            totalWidth += hasWidth || cellMinWidth;
            if (!hasWidth) {
                fixedWidth = false;
            }
            cols.push(['col', { style: buildColStyleString(cellMinWidth, hasWidth, responsiveWidths, { breakpoint: currentBreakpoint }) }]);
        }
    }
    const tableWidth = fixedWidth ? `${totalWidth}px` : '';
    const tableMinWidth = fixedWidth ? '' : `${totalWidth}px`;
    const colgroup = ['colgroup', {}, ...cols];
    return { colgroup, tableWidth, tableMinWidth };
}
